import React, { useState } from "react";
import MetaData from "../layout/MetaData";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveGoodsInfo } from "../../redux/features/userAddressInfoSlice";
import { GOODS_TYPE } from "../../constants/constants";

const GoodsInfo = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [goodsType, setGoodsType] = useState("Other");
  const [totalWeight, setTotalWeight] = useState("");
  const [volume, setVolume] = useState("");
  const [loadingType, setLoadingType] = useState("Labour");

  const submiHandler = (e) => {
    e.preventDefault();
    dispatch(saveGoodsInfo({ goodsType, totalWeight, loadingType, volume, userProposedAmount: "" }));
    navigate("/calculate-price");
  };

  return (
    <>
      <MetaData title="Goods Info" />
      <div className="row wrapper mb-5">
        <div className="col-10 col-lg-5">
          <form className="shadow rounded bg-body" onSubmit={submiHandler}>
            <h2 className="mb-4 text-center">Goods Information</h2>

            <div className="row">
              <div className="col-6 mb-3">
                <label htmlFor="goodsType_field" className="form-label">Goods Type</label>
                <select className="form-select" id="goodsType_field" value={goodsType} onChange={(e) => setGoodsType(e.target.value)} required>
                  {GOODS_TYPE?.map((category) => (
                    <option key={category} value={category}>{category}</option>
                  ))}
                </select>
              </div>
              <div className="col-6 mb-3">
                <label htmlFor="loadingType_field" className="form-label">Loading Type</label>
                <select className="form-select" id="loadingType_field" value={loadingType} onChange={(e) => setLoadingType(e.target.value)} required>
                  <option value="Labour">Labour</option>
                  <option value="Lifter">Lifter</option>
                  <option value="Crane">Crane</option>
                </select>
              </div>
            </div>

            <div className="row">
              <div className="col-6 mb-3">
                <label className="form-label">Total Weight (KG)</label>
                <div className="input-group">
                  <span className="input-group-text">KG</span>
                  <input type="number" className="form-control" value={totalWeight} onChange={(e) => setTotalWeight(e.target.value)} placeholder="0" required />
                </div>
              </div>
              <div className="col-6 mb-3">
                <label className="form-label">Volume (m³)</label>
                <div className="input-group">
                  <span className="input-group-text">m³</span>
                  <input type="number" className="form-control" value={volume} onChange={(e) => setVolume(e.target.value)} placeholder="0" required />
                </div>
              </div>
            </div>

            <button id="shipping_btn" type="submit" className="btn btn-primary w-100 py-2 mt-4">
              Continue
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default GoodsInfo;